import dayjs from 'dayjs';
import {GuestFormPrefillingData} from './types';
import {SelectOptionType} from '@guestapp/sdk';
import {
  isDateField,
  isLocationField,
  isPhoneField,
  isPhoneNumberTypeValid,
  isSelectField,
  isSelectOptionTypeValid,
} from '../guestForm';

const ALL_AVAILABLE_FIELDS: (keyof GuestFormPrefillingData)[] = [
  'name',
  'surname',
  'second_surname',
  'gender',
  'birth_date',
  'nationality',
  'document_type',
  'document_number',
  'visa_number',
  'document_issue_date',
  'document_expiration_date',
  'birth_place_country',
  'birth_place_address',
  'residence_country',
  'document_expedition_country',
  'residence_address',
  'next_destination_country',
  'next_destination_district',
  'next_destination_municipality',
  'next_destination_address',
  'residence_postal_code',
  'citizenship',
  'arrived_from_country',
  'arrived_from_district',
  'phone',
  'document_support_number',
  'kinship_relationship',
  'fiscal_code',
  'email',
];

const FORBIDDEN_FIELDS = [
  'residence_city',
  'document_expedition_city',
  'birth_place_city',
  'arrived_from_municipality',
  'next_destination_municipality',
];

const mapAndValidateGuestFormData = (guestFormData?: GuestFormPrefillingData) => {
  const res: Record<string, unknown> = {};

  if (!guestFormData) return;

  for (const [key, value] of Object.entries(guestFormData)) {
    if (!value) continue;

    if (FORBIDDEN_FIELDS.includes(key)) {
      console.warn(`The ${key} field cannot be prefilled`);
    } else if (isSelectField(key)) {
      res[key] = {
        label: '',
        value: typeof value === 'string' ? value : (value as SelectOptionType)?.value,
      };
    } else if (isLocationField(key)) {
      if (isSelectOptionTypeValid(value)) {
        res[key] = {
          label: value.label,
          value: value.value,
        };
      } else {
        console.warn(
          `Value of the ${key} field is not a valid. The format should be {label: string, value: string}`,
        );
      }
    } else if (isDateField(key)) {
      if (dayjs(value as string).isValid()) {
        res[key] = value;
      } else {
        console.warn(`Value of the ${key} field is not a valid date`);
      }
    } else if (isPhoneField(key)) {
      if (isPhoneNumberTypeValid(value)) {
        res[key] = {
          code: value.code?.startsWith('+') ? value.code : `+${value.code}`,
          number: value.number,
        };
      } else {
        console.warn(
          `Value of the ${key} field is not a valid phone number. The format should be {code: string, number: string}`,
        );
      }
    } else if (ALL_AVAILABLE_FIELDS.includes(key)) {
      res[key] = value;
    } else {
      console.warn(`The ${key} field doesn't exist in the form`);
    }
  }

  return res as GuestFormPrefillingData;
};

export {mapAndValidateGuestFormData};
